export default {
  contentTable: {},
  contentFather: {},
  content: {
    width: '100%',
    height: '350px',
    margin: '0 auto',
    background: '#fff',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media(min-width:901px)':{
      width: '600px',
      height: '450px',
    },
  },
  closeButton: {
    top: '15px',
    float: 'right',
    position: 'absolute',
    zIndex: '600',
    background: 'none',
    cursor: 'pointer',
    color: data => data.mainColor,
    border: '0',
    fontSize: '16px',
    right: '15px',
    outline: 'none !important',
    padding: '10.5px 12px',
    '&:lang(ar)':{
      left:'40px',
      right:'auto',
      float:'left',
    },
    '@media(min-width:901px)':{
      outline: 'none !important',
      fontSize: '20px',
      top: '15px',
      right: '20px',
      padding: '10px 12px',
      '&:lang(ar)':{
        left:'40px',
        right:'auto',
        float:'left',
      },
    },
  },
  modalStyle: {
    position: 'fixed',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    padding: '20px',
    background: 'rgba(0,0,0,0.5)',
    zIndex: '600',
    overflow: 'auto',
    '@media(min-width:901px)':{
      padding: '50px',
    },
    '& $contentTable': {
      width:'100%',
      height:'100%',
      display:'flex',
      flexDirection:'column',
      justifyContent:'center',
      '& $contentFather': {
        textAlign: 'center',
      },
      '& $content': {
        maxWidth: '1181px',
        margin: '0 auto',
        background: '#fff',
        position: 'relative',
      },
    },
    '&#calendarModal':{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      zIndex:'500',
      '@media(min-width:801px)':{
        zIndex:'502',
      },
    },
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '20px',
    '& div > div > svg': {
      width: '40px',
      height: '40px',
    },
    '@media(min-width:901px)':{
      gap: '40px',
      '& div > div > svg': {
        width: '44px',
        height: '44px',
      },
    },
  },
  buttonsBox: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    alignItems: 'center',
    marginTop: '10px',
    '@media(min-width:901px)':{
      gap: '50px',
    },
  },
  contentButton: {
    width: '120px',
    height: '35px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media(min-width:901px)':{
      width: '150px',
      height: '50px',
    },
  },
  contentSubtitle: {
    font: "300 14px 'Roboto', sans-serif",
    padding: '0',
    '@media(min-width:901px)':{
      fontSize: '16px',
      padding: '0 65px',
    },
  },
};
